module.exports = "<ea-invoice-page></ea-invoice-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaInvoice/invoiceModule.html
// module id = 980
// module chunks = 12